import { useQuery } from '@tanstack/react-query'

import { NudgingSubscriptionBanner } from '@/pages/ui/nudging-subscribe-banner/nudging-subscribe-banner'

import { LOCAL_STORAGE_KEY_MAP } from '@/lib/constants/platform'
import { useRedirect } from '@/lib/hooks/use-redirect'
import { getUserQuery } from '@/lib/queries/business/v2/user/queries'
import { cn } from '@/lib/utils'

import { ContentWrapper } from '../../ui/content-wrapper/content-wrapper'
import { Footer } from '../../ui/footer/footer'
import { ClientPortalInternalSampleContent } from './ui/client-portal-internal-sample-content/client-portal-internal-sample-content'
import { ClientPortalInternalSampleHeader } from './ui/client-portal-internal-sample-header/client-portal-internal-sample-header'

export const ClientPortalInternalSamplePage = () => {
  const { data: dataUser } = useQuery(getUserQuery)

  const loginToken = localStorage.getItem(LOCAL_STORAGE_KEY_MAP.token)
  useRedirect({ condition: !loginToken || !!dataUser?.hasSubscription, redirectTo: '/' })

  return (
    <>
      <ContentWrapper>
        <div className={cn('w-full', 'mb-16', 'bg-tomato')}>
          <NudgingSubscriptionBanner
            contentFlow="vertical"
            isAdmin={dataUser?.isAdmin}
            isFreeTrialAvailable={dataUser?.isFreeTrialAvailable}
          />
        </div>
        <div className={cn('relative', 'outline outline-8 outline-offset-[16px] outline-orange-400', 'pt-[70px]')}>
          <div
            className={cn(
              'absolute right-[-20px] top-[-20px]',
              'bg-orange-400',
              'p-5',
              'text-2xl font-semibold text-white',
              'rounded-[8px]'
            )}
          >
            DEMO VIEW
          </div>
          <ClientPortalInternalSampleHeader />
          <ClientPortalInternalSampleContent />
        </div>
      </ContentWrapper>

      <Footer />
    </>
  )
}
